module.exports = __webpack_public_path__ + "static/media/p4_4.ecc12bf4.png";